import { useCallback, useContext, useMemo } from 'react';

import classnames from 'classnames';

import { MainContext } from '@ezbobdev/ui-framework';

export const useFlow = (props) => {
  const { className } = props;
  const { actions } = useContext(MainContext);
  const pageDetails = actions.userState.getCurrentPageDetails();
  const pageName = pageDetails.pageName;

  const getPageNameClass = useCallback(() => {
    return pageDetails.pageName && `page-${pageName}`;
  }, [pageName]);

  const pageNameClass = useMemo(() => getPageNameClass(), [pageName]);

  const wrapperClasses = useMemo(() => classnames(`Flow`, pageNameClass, className), [pageNameClass, className]);

  return { wrapperClasses };
};
